import { motion } from 'framer-motion';

const goldenPulse = {
  borderColor: ['#FFD740', '#E6A800', '#FFD740'],
};

export default function GoldenDreamCard({ dream, onExplore, isExplored, petName }) {
  const displayHook = (dream.dream_hook || '').replace(/\biki\b/gi, petName || 'Your pet');

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1, ...goldenPulse }}
      transition={{
        opacity: { delay: 0.5, duration: 0.4 },
        scale: { delay: 0.5, type: 'spring', stiffness: 300, damping: 25 },
        borderColor: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
      }}
      whileTap={{ scale: 0.98 }}
      onClick={() => !isExplored && onExplore(dream)}
      role="button"
      tabIndex={0}
      aria-label={`Explore golden dream about ${dream.topic || 'cross-subject'}`}
      onKeyDown={(e) => { if (e.key === 'Enter' && !isExplored) onExplore(dream); }}
      style={{
        background: 'rgba(255,215,64,0.04)',
        border: '2px dashed #E6A800',
        borderLeft: '3px solid #FFD740',
        borderRadius: 4,
        padding: 16,
        cursor: isExplored ? 'default' : 'pointer',
        opacity: isExplored ? 0.7 : 1,
        position: 'relative',
        boxShadow: 'none',
      }}
    >
      {/* Golden badge */}
      <span style={{
        position: 'absolute', top: 10, right: 10,
        fontSize: 14, fontFamily: "'Patrick Hand', cursive",
        padding: '4px 12px', borderRadius: 14,
        background: 'rgba(255,215,64,0.15)', color: '#E6A800',
        lineHeight: 1,
      }}>
        Golden Dream
      </span>

      {/* Emoji */}
      <span style={{ fontSize: 28, display: 'block', marginBottom: 4 }}>
        {dream.emoji || '✨'}
      </span>

      {/* Dream hook */}
      <p style={{
        fontSize: 16, fontFamily: "'Patrick Hand', cursive",
        color: '#1A1A2E', lineHeight: 1.5,
        margin: '8px 0 14px', paddingRight: 80,
      }}>
        {displayHook}
      </p>

      {/* Bottom row: explore + 3x stars label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button
          onClick={(e) => { e.stopPropagation(); if (!isExplored) onExplore(dream); }}
          disabled={isExplored}
          style={{
            fontSize: 14, fontFamily: "'Patrick Hand', cursive",
            padding: '8px 16px', borderRadius: 20,
            border: 'none',
            background: isExplored ? '#66BB6A' : '#FFD740',
            color: isExplored ? '#FFFFFF' : '#7A5800',
            cursor: isExplored ? 'default' : 'pointer',
            minHeight: 40, minWidth: 48,
          }}
        >
          {isExplored ? 'Explored!' : 'Explore this dream'}
        </button>
        {!isExplored && (
          <span style={{
            fontSize: 14, fontFamily: "'Patrick Hand', cursive",
            color: '#E6A800',
          }}>
            3x Stars!
          </span>
        )}
      </div>
    </motion.div>
  );
}
